import React, { useEffect, useState } from "react";
import SnpComponent from "../../global/SnpComponent";
import '../createRoom/Room.css';

import useAuth from "../../hooks/useAuth";
import { BookStatus, HotelRoomCateogory, RoomBillTableBtnClick, isEmpty, isFeatureAllowed, printDebugLog } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import { FormControlLabel, Grid, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import { AdvanceBooking } from "../component/AdvanceBooking";
import { INITIAL_SNP_COMPONENT } from "../../constants/pojoservice";
import { fetchMainBillFromRoom, getMainCateogoryData, getMainRoomData } from "../createBanquetBill/networkController";
import { CateogoryView } from "../component/CateogoryView";
import { RoomBanquetView } from "../component/RoomBanquetView";
import { RoomBillTableData } from "../component/RoomBillTableData";
import { RoomTodayView } from "../component/RoomTodayView";
import { TODAY_FORMAT_DATE } from "../../constants/DateUtils";
import { ADVANCEBOOKING } from "../../constants/Permissions";



export default function BookRoom() {


    const navigate = useNavigate();
    const { activeShopHash, authUser } = useAuth();
    const [snpLoader, setSnpLoader] = useState(false);
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const [roomData, setRoomData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categories, setCateogories] = useState([]);

    const [billingDataList, setBillingDataList] = useState([]);
    const [dialog, setDialog] = useState(false);
    const [singleRoom, setSingleRoom] = useState(null);
    const [newBookingAllowed, setNewBookingAllowed] = useState(true);
    const [filterSelection, setFilterSelection] = useState(0); //0 means Today's booking , 1 means All booking


    useEffect(() => {
        getCateogoryData();
    }, []);

    useEffect(() => {
        printDebugLog("useEffect BookRoom ", selectedCategory);
        getRoomData(TODAY_FORMAT_DATE, 0); //Always be 0 means toda's booking
    }, [selectedCategory])

    const getRoomData = async (selectedDate, mFilter) => {
        await getMainRoomData({
            authUser: authUser,
            activeShopHash: activeShopHash,
            selectedCategory: selectedCategory,
            type: HotelRoomCateogory.HOTEL_ROOM,
            selectedDate: isEmpty(selectedDate) ? "" : selectedDate,
            setSnpLoader: setSnpLoader,
            onResponseCallback: (payLoad, error) => {
                if (!error) {
                    setRoomData(payLoad?.data ?? []);
                    setFilterSelection(mFilter);
                } else {
                    setRoomData([]);
                    setSnpComponent({
                        ...snpComponent,
                        isLoader: false,
                        negativeReq: true,
                        negativeAction: "Dismiss",
                        positiveAction: "Create Room",
                        positiveReq: true,
                        showDialog: true,
                        outSideClickDismiss: true,
                        cancelExtra: true,
                        subTitle: `No Room is Available with '${selectedCategory?.catgName}' ! Please create`,
                        handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                        handleSnpSubmit: () => navigate("/createroom"),
                    });
                }
            }
        });
    };


    const getCateogoryData = async () => {
        await getMainCateogoryData({
            authUser: authUser,
            activeShopHash: activeShopHash,
            onResponseCallback: (fullData, error) => {
                if (!error) {
                    setCateogories(fullData);
                    setSelectedCategory(fullData[0]);
                } else {
                    setCateogories([]);
                }
            }
        });
    };

    const fetchBillFromRoom = async (data) => {
        await fetchMainBillFromRoom({
            authUser: authUser,
            activeShopHash: activeShopHash,
            mRoom: data,
            setSnpLoader: setSnpLoader,
            onResponseCallback: (fullData, newBookingNotAllowed, error) => {
                setNewBookingAllowed(!newBookingNotAllowed);
                if (!error) {
                    setBillingDataList(fullData);
                    setDialog(true);
                    setSingleRoom(data);
                } else {
                    setSnpComponent(prev => ({
                        ...prev,
                        snackBarMsg: "No Data available",
                        snackBarOpen: true,
                    }));

                }
            }
        })
    }

    const handleOnClick = (type, id, banquetBooking) => {
        printDebugLog("handleOnClick", type, id, banquetBooking);
        if (banquetBooking) {
            navigate("/createBanquetBill", { state: { id: id, via_bill: 1 } });
        } else {
            if (type === RoomBillTableBtnClick.No_Booking_Click) {
                setBillingDataList([]);
                setDialog(false);
                setSingleRoom(null);
            } else {
                const via_bill = type === RoomBillTableBtnClick.New_Booking_Click ? 0 : 1;
                navigate("/createBill", { state: { id: id, via_bill: via_bill } });
            }

        }
        setNewBookingAllowed(true);
    };

    const handleRoomBanquetClick = (data) => {
        printDebugLog("handleRoomBanquetClick", data);
        const roomBookedStatus = data?.roomBookedStatus ?? BookStatus.No_Booking;
        if (roomBookedStatus === BookStatus.No_Booking) {
            navigate("/createBill", { state: { id: data.id, via_bill: 0 } });
        } else if (roomBookedStatus === BookStatus.Single_Booking) {
            const billingData = data?.billingData ?? null;
            setSingleRoom(data);
            setNewBookingAllowed(!(data?.newBookingNotAllowed ?? false));
            setBillingDataList((prevList) => [...prevList, billingData]);
            setDialog(true);
        } else {
            fetchBillFromRoom(data);
        }
    };

    const handleBookRoom = (data) => {
        printDebugLog("handleBookRoom", data);
        if ((data?.roomBookedStatus ?? BookStatus.Single_Booking) === BookStatus.Multiple_Booking) {
            setSnpComponent({
                ...snpComponent,
                isLoader: false,
                negativeReq: true,
                negativeAction: "Ok",
                positiveAction: "Check Booking",
                positiveReq: true,
                showDialog: true,
                outSideClickDismiss: true,
                cancelExtra: true,
                subTitle: `There is multiple booking at this time, Please check booking for more info`,
                handleSnpSubmit: () => fetchBillFromRoom(data),
                handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
            });
            return;
        }

        if (data?.banquetBooking ?? false) {
            //Added on 30Aug
            navigate("/createBanquetBill", { state: { id: data.billId, via_bill: 1 } });
        } else {
            //Case for Today , it will be always booked , so keep via_bill : 1 means search via bill
            navigate("/createBill", { state: { id: data.billId, via_bill: 1 } });
        }
    };

    const renderSnpContent = () => {
        return (
            <>
                <Grid container spacing={1}
                    display="flex"
                    alignItems="center" sx={{
                        padding: 2,
                    }}>

                    <Grid item xs={12}>
                        <center>
                            <Typography variant="h3" >
                                Room Availability
                            </Typography>
                        </center>
                    </Grid>

                    <Grid item xs={12}>
                        <CateogoryView
                            categories={categories}
                            selectedCategory={selectedCategory}
                            setSelectedCategory={setSelectedCategory} />
                    </Grid>
                    <Grid item xs={12}>
                        <Paper
                            elevation={4}
                            sx={{
                                borderRadius: 2,
                                p: 2,
                                backgroundColor: "#f5f5dc",
                            }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <RadioGroup
                                        row
                                        aria-label="type"
                                        name="type"
                                        value={filterSelection}
                                        onChange={(e) => {
                                            const val = Number(e.target.value);
                                            if (val === 0) {
                                                getRoomData(TODAY_FORMAT_DATE, 0);
                                            } else {
                                                getRoomData("", 1);
                                            }
                                        }}
                                    >
                                        <FormControlLabel
                                            value={0}
                                            control={<Radio />}
                                            label="Today's Booking"
                                        />
                                        <FormControlLabel
                                            value={1}
                                            control={<Radio />}
                                            label="Rest of Booking"
                                        />
                                    </RadioGroup>
                                </Grid>

                                {
                                    roomData.length > 0 &&
                                    roomData.map(data => (
                                        <Grid item md={1.5} xs={6} sm={4} sx={{
                                            padding: 0, m: 2,
                                        }}>
                                            {
                                                filterSelection === 0 ?
                                                    <RoomTodayView
                                                        data={data}
                                                        handleBookRoom={handleBookRoom} />
                                                    : <RoomBanquetView
                                                        data={data}
                                                        handleRoomBanquetClick={handleRoomBanquetClick} />
                                            }

                                        </Grid>
                                    ))
                                }
                                {
                                    roomData.length === 0 &&
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle4" component="div" style={{
                                            fontWeight: 'bold', fontSize: '16px', color: "#2f1160", whiteSpace: 'pre-wrap',
                                            overflowWrap: 'break-word'
                                        }}
                                        >
                                            No booking available today
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper
                            elevation={4}
                            sx={{
                                borderRadius: 2,
                                p: 2,
                                backgroundColor: "#fffadf",
                            }}>
                            <Grid container spacing={1}>
                                {
                                    isFeatureAllowed(authUser.packages, ADVANCEBOOKING) &&
                                    <Grid item xs={12}>
                                        <center>
                                            <Typography variant="h6" >
                                                Advance Booking
                                            </Typography>
                                        </center>
                                    </Grid>
                                }
                                {
                                    isFeatureAllowed(authUser.packages, ADVANCEBOOKING) && <Grid item xs={12}>
                                        <AdvanceBooking
                                            bookingCount={{}}
                                            previousDateBooking={[]}
                                            setSnpComponent={setSnpComponent}
                                            navigate={(id, inDate, outDate) => navigate("/createBill", { state: { id: id, via_bill: 0, checkInDate: inDate, checkOutDate: outDate } })}
                                            clearSnpComponent={() => setSnpComponent(INITIAL_SNP_COMPONENT)}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Paper>
                    </Grid>
                    <RoomBillTableData
                        dialog={dialog}
                        newBookingAllowed={newBookingAllowed}
                        singleRoom={singleRoom}
                        billingDataList={billingDataList}
                        handleOnClick={handleOnClick} />
                </Grid>
            </>
        )
    };

    return (
        <>
            <SnpComponent showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                isLoader={snpLoader}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                iconReq={snpComponent.iconReq}
                iconContent={snpComponent.iconContent}
                content={renderSnpContent()}
                onSnackClose={() => setSnpComponent({
                    ...snpComponent,
                    snackBarOpen: false,
                    snackBarMsg: "",
                })}
                handleSubmit={snpComponent.handleSnpSubmit}
                onCancel={snpComponent.handleSnpCancel}
                cancelExtra={snpComponent.cancelExtra}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </>
    );
}